import { TabItem } from '../models';
import { ActionSettingTypeCodes } from '../models/PanelActionsSettings';
import { DROPDOWN_OPERATORS } from '../mocks/data';

export const TAB_ITEMS: TabItem<string>[] = [
  {
    menuIcon: {
      type: 'icon',
      value: 'pi pi-align-right',
      prime: true,
      size: 'medium',
    },
    contentTemplate: null,
  },
  {
    menuIcon: { type: 'icon', value: 'gem', prime: false, size: 'xl' },
    contentTemplate: null,
  },
];

export const SEGMENT_RADIO_BUTTONS = [
  { label: 'Driver completes previous segment ', value: 'driver' },
  { label: 'Conditional', value: 'conditional' },
];

export const SEGMENT_OPTION_STATUS = [
  { name: 'Completed', code: 'C' },
  { name: 'In Progress', code: 'I' },
  { name: 'Failed', code: 'F' },
];

export const SET_CONDITIONS = {
  optionsSelectButtonSelected: 'and',
  optionsSelectButtonTopSelected: '',
  optionsSelectButtonTop: [
    { label: 'Simple', value: 'simple' },
    { label: 'Combined (AND, OR)', value: 'combined' },
  ],
  optionsSelectButton: [
    { label: 'AND', value: 'and' },
    { label: 'OR', value: 'or' },
  ],
  descriptionSelectButton: '',
  treeSelectOptionsIf: [],
  treeSelectOptionsThen: [],
  operators: DROPDOWN_OPERATORS,
};

export const OPTIONS_JSON = [
  { label: 'Json Value', value: 'json' },
  { label: 'Workflow Value', value: 'workflow' },
];

/**
 * Per-action restriction of the conditions/blockers authoring UI for the three
 * Start-segment commit actions. Mirrors the backend validation in
 * workflow-definition (ConditionalsService):
 *  - showConditionTab: when false, the "Single conditions" tab is hidden and only
 *    a Blocker may be configured.
 *  - jsonOnly: when true, operands may reference a JSON/load value only (the
 *    "Workflow Value" source is removed).
 *
 * Keyed on the NORMALIZED ActionSettingTypeCodes (START/ACCEPT/DECLINE), which is
 * what action-properties-sidebar.actionSettings() returns for STARTLOAD /
 * ACCEPTLOAD / DECLINELOAD. Any action type not listed here (and segment/step
 * scope) keeps the unrestricted default.
 */
export interface ConditionAuthoringRestriction {
  showConditionTab: boolean;
  jsonOnly: boolean;
}

export const DEFAULT_CONDITION_AUTHORING_RESTRICTION: ConditionAuthoringRestriction =
  { showConditionTab: true, jsonOnly: false };

export const COMMIT_ACTION_CONDITION_RESTRICTIONS: Partial<
  Record<ActionSettingTypeCodes, ConditionAuthoringRestriction>
> = {
  // Start Workflow: blocker only; JSON value AND workflow value allowed.
  [ActionSettingTypeCodes.START]: { showConditionTab: false, jsonOnly: false },
  // Accept: blocker only; JSON value only.
  [ActionSettingTypeCodes.ACCEPT]: { showConditionTab: false, jsonOnly: true },
  // Decline: single condition or blocker; JSON value only.
  [ActionSettingTypeCodes.DECLINE]: { showConditionTab: true, jsonOnly: true },
};
